import type { Theme } from '@mui/material';
import { Box } from '@mui/material';
import type React from 'react';
import { combineSx } from '@/utils/combineSx';

const filterBarStyles = {
  root: (theme: Theme) => ({
    position: 'relative',
    display: 'grid',
    gap: '0.75rem',
    padding: '0.5rem 1rem',
    borderBottom: `solid ${theme.palette.baseColors.black.c12} thin`,
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '1fr auto',
      alignItems: 'center',
    },
  }),
  filters: {
    gap: '0.75rem',
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 1fr)',
    alignItems: 'start',
  },
  actions: {
    display: 'flex',
    gap: '0.75rem',
    alignItems: 'center',
  },
};

type RootProps = React.ComponentProps<typeof Box>;

const Root = ({ children, ...props }: RootProps) => {
  return (
    <Box sx={filterBarStyles.root} data-id='filter-bar-root' {...props}>
      {children}
    </Box>
  );
};

type FiltersProps = React.ComponentProps<typeof Box>;

const Filters = ({ children, sx, ...props }: FiltersProps) => {
  const mergedSx = combineSx(filterBarStyles.filters, sx);

  return children ? (
    <Box sx={mergedSx} data-id='filter-bar-filters' {...props}>
      {children}
    </Box>
  ) : null;
};

type ActionsProps = React.ComponentProps<typeof Box>;

const Actions = ({ children, sx, ...props }: ActionsProps) => {
  const mergedSx = combineSx(filterBarStyles.actions, sx);

  return children ? (
    <Box sx={mergedSx} data-id='filter-bar-actions' {...props}>
      {children}
    </Box>
  ) : null;
};

const FilterBarComposable = {
  Root,
  Filters,
  Actions,
};

export { FilterBarComposable };
